import { httpClient } from '../network/httpclient/HttpClientFactory';
import { wrapHttpClient } from '../helper/HttpHelper';

const subCodeList = (code, depth) => httpClient.get(`/code/${code}/${depth}`).then(res => res.data);

export default {
    subCodeList
};
